import ReactRRuleGenerator from './components/ReactRRuleGenerator';
import translations from './translations';

export default ReactRRuleGenerator;
export { translations };
